import { FOOTER_NAV, FOOTER_TAGLINE } from "../../shared/seo/navigation";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <p>{FOOTER_TAGLINE}</p>
      {/* Secondary destinations only; the list and its reasoning live in navigation.ts,
          which the pre-rendered HTML reads too. */}
      <div>
        {FOOTER_NAV.map((link) => <a href={link.href} key={link.href}>{link.label}</a>)}
      </div>
    </footer>
  );
}
